// Hooks
import { useState } from "react";
// Components
import SimpleIconButton from "@/Layouts/components/Buttons/SimpleIconButton";
// MUI
import { Stack } from "@mui/material";
import { GridToolbarQuickFilter } from "@mui/x-data-grid-premium";
import Badge from "@mui/material/Badge";
import { GridState, useGridApiContext, useGridSelector } from "@mui/x-data-grid-pro";

// Icons
import { SearchOffIcon, SearchOnIcon } from "../CustomIcons";

interface IQuickFilterProps {
	disabled?: boolean;
	initiallyOpened?: boolean;
}

export const QuickFilter = (props: Readonly<IQuickFilterProps>) => {
	const [open, setOpen] = useState(props.initiallyOpened ?? false);

	const { disabled } = props;

	const apiRef = useGridApiContext();

	const hasQuickSearchValue = !!useGridSelector(apiRef, (state: GridState) => state?.filter?.filterModel?.quickFilterValues?.length);

	if (!open || disabled) {
		return (
			<>
				<SimpleIconButton disabled={disabled} onClick={() => setOpen(true)} icon={<SearchOnIcon />} />
				{hasQuickSearchValue && (
					<Badge
						color="secondary"
						badgeContent={1}
						className={
							"[&_.MuiBadge-badge]:bg-medium-pink [&_.MuiBadge-badge]:right-1 [&_.MuiBadge-badge]:top-[21px] " +
							"[&_.MuiBadge-badge]:p-[0_4px] [&_.MuiBadge-badge]:border-2 pointer-events-none"
						}
					/>
				)}
			</>
		);
	}

	return (
		<Stack direction="row" justifyContent="center" alignItems="center">
			<GridToolbarQuickFilter
				variant="standard"
				placeholder="Search..."
				autoFocus
				className="!w-[155px] !ml-0 !align-middle !pb-0"
				InputProps={{
					className: "[&_input]:!ml-0 before:!border-b-black/[42%] hover:before:!border-b-black/[87%] ",
					startAdornment: null,
				}}
			/>
			<SimpleIconButton onClick={() => setOpen(false)} icon={<SearchOffIcon />} />
		</Stack>
	);
};
